module.exports = {
      id: "4627ff4327bc5a34b5fe0aadb8b1e040construction-prefab.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#4627ff4327bc5a34b5fe0aadb8b1e040construction-prefab.svg",
      toString: function () {
        return this.url;
      }
    }